import React, { useState, useEffect, useContext, useRef } from 'react';
import { useRouteMatch } from 'react-router-dom';
import { Detector } from 'react-detect-offline';

import { AuthContext } from '../reducers/Auth/AuthContext';
import { EventsStoreContext } from '../reducers/Events/EventsContext';
import { PlaceStoreContext } from '../reducers/Place/PlaceContext';

import { WebSockets } from '../apis/WSConnection';
import { messageHandler } from '../apis/messageHandler';

import { uri } from '../utils/config';

export const WSContext = React.createContext();
export const Offline = () => (
  <div
    style={{
      position: 'fixed',
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      zIndex: 999,
      backgroundColor: 'white',
      textAlign: 'center',
      color: 'black',
      justifyContent: 'center',
      alignItems: 'center',
    }}
  >
    <h1>NO SERVER CONNECTION, TRYING TO RECONNECT ...</h1>
  </div>
);

export const WSProvider = ({ children }) => {
  const [WSConnection, setWSConnection] = useState(null);
  const [isOnline, setIsOnline] = useState(true);

  const isLoginRoute = useRouteMatch('/login');
  const isErrorRoute = useRouteMatch('/error');

  const [placeState, placeDispatch] = useContext(PlaceStoreContext);
  const [eventsState, eventsDispatch, { getEvents }] = useContext(EventsStoreContext);

  const [authState] = useContext(AuthContext);
  const { authenticated, user, loading } = authState;
  const { placeId, userId } = user;
  const isAuthenticated = authenticated && placeId?.length > 1 && userId;

  const onWSMessage = async (message, connection) => {
    const reducers = { eventsDispatch, placeDispatch };
    return messageHandler(message, reducers, {}, connection);
  };

  useEffect(() => {
    if (!isOnline) {
      console.log('NOT ONLINE');
      WebSockets.clear();
    }

    if (isOnline && isAuthenticated && !WSConnection && !loading) {
      WebSockets.setNewPlaceId(placeId);
      WebSockets.setNewUserId(userId);
      WebSockets.setOnMessage(onWSMessage);
      WebSockets.setCallback(setWSConnection);
      WebSockets.connect();
    }

    if (!isAuthenticated && !loading) {
      WebSockets.connection && WebSockets.disconnect();
    }
  }, [authenticated, placeId, userId, isOnline, loading, placeState]);

  const logout = async () => {
    WebSockets.disconnect();
  };

  return (
    <WSContext.Provider value={{ WSConnection, setWSConnection, logout }}>
      <Detector
        render={({ online }) => {
          setIsOnline(online);
          if (!online) {
            return <Offline />;
          }

          return children;
        }}
        polling={{
          enabled: true,
          url: `${uri.orders}/api/health/ping`,
          interval: 60000,
          timeout: 5000,
        }}
      />
    </WSContext.Provider>
  );
};
